import React from 'react';
import { FaCheckCircle, FaTimesCircle } from 'react-icons/fa';
import { Trans } from 'react-i18next';
import styles from './WebsiteChatMessage.module.scss';
import classNames from 'classnames';
const WebsiteChatMessage = ({ message }) => {
    return (React.createElement("div", { className: styles.websiteChatMessage },
        React.createElement("div", { className: styles.status },
            React.createElement("div", { className: classNames(styles.statusIcon, {
                    [styles.active]: message.status === 'ACTIVE',
                    [styles.inactive]: message.status === 'OFFLINE',
                }) }, message.status === 'ACTIVE' ? React.createElement(FaCheckCircle, null) : React.createElement(FaTimesCircle, null)),
            React.createElement("div", { className: styles.statusText }, message.status === 'ACTIVE' ? (React.createElement(Trans, { i18nKey: "websiteChatMessage.onlineStatus" })) : (React.createElement(Trans, { i18nKey: "websiteChatMessage.offlineStatus" }))))));
};
export default WebsiteChatMessage;
